import React from 'react';
import clsx from 'clsx';
import { Button, ButtonProps } from '@material-ui/core';
import useEventTracking from 'hooks/useEventTracking';
import useButtonDisabling from 'hooks/useButtonDisabling';
import { GlobalServices } from 'utils';
import { EventActions } from 'types/eventTracking';
import globalStyles from 'styles/globalStyles';
import styles from './styles';

type Props = ButtonProps & {
    marginHorizontal?: boolean;
    marginVertical?: boolean;
    trackingCategory?: string;
    trackingName?: string;
    applyDisabledStyle?: boolean;
    disabledStyle?: any;
    alternativeFont?: boolean;
};

const ApariButton: React.FC<Props> = ({
    children,
    className,
    disabled,
    applyDisabledStyle,
    disabledStyle,
    marginVertical,
    type,
    marginHorizontal,
    onClick,
    trackingName,
    trackingCategory,
    alternativeFont,
    ...rest
}) => {
    const { delayButtonActivity, buttonDisabled } = useButtonDisabling();
    const { marginVertical: marginVerticalClass, marginHorizontal: marginHorizontalClass, ...otherClasses } = styles();
    const { trackingEvent } = useEventTracking();
    const globalClasses = globalStyles();

    const clickHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (type === 'submit') setTimeout(() => delayButtonActivity(), 1);
        if ((type === 'submit' || GlobalServices.isDefined(onClick)) && GlobalServices.isDefined(trackingCategory)) {
            trackingEvent({ category: trackingCategory, action: EventActions.CLICK, name: trackingName });
        }
        if (GlobalServices.isDefined(onClick)) {
            onClick(event);
        }
    };
    return (
        <Button
            className={clsx(
                marginVertical ? marginVerticalClass : '',
                marginHorizontal ? marginHorizontalClass : '',
                className,
                alternativeFont && globalClasses.fontRoboto,
                applyDisabledStyle && disabled ? (disabledStyle ? disabledStyle : globalClasses.disabled) : ''
            )}
            classes={otherClasses}
            onClick={clickHandler}
            type={type}
            disabled={buttonDisabled || disabled}
            {...rest}
        >
            {children}
        </Button>
    );
};

export default ApariButton;
